export default __webpack_public_path__ + "a5ed39892548d02fa69740159aff584f.png";